import React, { useEffect, useState } from "react";
import handleApi from "./api/api";

const getDelta = (a, b) => {
  const intA = parseInt(a);
  const intB = parseInt(b);

  const delta = (intB - intA) / 1000;
  return delta;
};

const AWSManagement = ({
  setAudioFiles,
  setVideoFiles,
  setFinalAudio,
  hasAudio,
}) => {
  const [folders, setFolders] = useState([]);
  const [contents, setContents] = useState([]);
  const [callStartTimes, setCallStartTimes] = useState([]);

  const generateAudio = async (cid) => {
    console.log("axios call");
    const res = await handleApi(
      `recordProcess`,
      'POST',
      {
        callerId: cid,
        env: process.env.ENV_NAME || "prod",
      }
    );

    // Refresh the page to get the final_audio.webm
    window.location.reload();

    console.log("Waiting for response will be back soon");
  };

  useEffect(() => {
    const fetchS3Contents = async () => {
      try {
        // Get cid parameter from URL
        const urlParams = new URLSearchParams(window.location.search);
        const cid = urlParams.get("cid");
        const prefix = cid || "0ca712af-a5b3-4681-b318-a9f0c1210e12";

        const response = await handleApi(
          `/s3/list-objects/${encodeURIComponent(prefix)}?delimiter=iconnect-final-files`,
          'GET'
        );

        if (!response.success) {
          throw new Error('Failed to fetch S3 contents');
        }

        const contents = response.data.contents;
        let startTimeStamp = null;
        let endTimeStamp = null;
        const folders = [];
        const audioFolders = [];

        setContents(contents);
        
        contents.forEach((content, i) => {
          const folder = content.Key.split("/")[1];
          if (
            !audioFolders.includes(folder) &&
            folder !== "output" &&
            folder !== "merge_process_started" &&
            folder !== "final_audio" &&
            folder.includes("audio")
          ) {
            audioFolders.push(folder);
            const folderContents = contents.filter((content) =>
              content.Key.includes(folder)
            );
            
            if (folderContents.length > 0) {
              folders.push(folder);
              const sortedFolderContents = folderContents.sort((a, b) => {
                if (a.Key > b.Key) return 1;
                return -1;
              });

              // Use presigned URLs from the API response
              const URLS = sortedFolderContents.map((content) => {
                return content.signedUrl || `https://iconnect-final-recordings.s3.us-east-2.amazonaws.com/${content.Key}`;
              });

              if (!startTimeStamp) {
                startTimeStamp = sortedFolderContents[0].Key.split("/")[2].split(".")[0];
              }

              if (!endTimeStamp && i > 0) {
                endTimeStamp = sortedFolderContents[0]?.Key.split("/")[2].split(".")[0];
              }

              setAudioFiles((audioFiles) => [
                ...audioFiles,
                {
                  [`audio${audioFolders.length - 1}`]: URLS,
                },
              ]);
            }
          }
          
          if (
            !folders.includes(folder) &&
            folder !== "output" &&
            folder !== "merge_process_started" &&
            folder !== "final_audio" &&
            folder.includes("video")
          ) {
            const folderContents = contents.filter((content) =>
              content.Key.includes(folder)
            );
            
            if (folderContents.length > 0) {
              folders.push(folder);
              const sortedFolderContents = folderContents.sort((a, b) => {
                if (a.Key > b.Key) return 1;
                return -1;
              });

              const videoStartTimestamp = sortedFolderContents[0].Key.split("/")[2].split(".")[0];
              const delay = getDelta(startTimeStamp, videoStartTimestamp);
              const videoDelay = delay;
              const delayPerMinute = 1;
              const loadDelay = parseInt(delay / 15) * delayPerMinute;
              const fDelay = videoDelay;

              setVideoFiles((videoFiles) => [
                ...videoFiles,
                {
                  id: folder,
                  name: folder,
                  delay: fDelay * 1000,
                  chunks: sortedFolderContents.map((content) => ({
                    key: content.Key,
                    signedUrl: content.signedUrl || `https://iconnect-final-recordings.s3.us-east-2.amazonaws.com/${content.Key}`,
                  })),
                },
              ]);
            }
          }
        });

        if (audioFolders.length > 0) {
          const sortedAudioFolders = audioFolders.sort((a, b) => a > b ? 1 : -1);
          const callStartTimes = sortedAudioFolders.map((folder) =>
            folder.replace("audio__", "")
          );
          setCallStartTimes(callStartTimes);
        }

        setFolders(folders);

        if (contents.length > 0) {
          const tempAudio = contents.filter((content) =>
            content.Key.includes("final_audio.webm")
          );
          if (tempAudio.length > 0) {
            setFinalAudio(
              tempAudio[0].signedUrl || `https://iconnect-final-recordings.s3.us-east-2.amazonaws.com/${tempAudio[0].Key}`
            );
          }
        }
      } catch (error) {
        console.error("Error fetching S3 contents:", error);
      }
    };

    fetchS3Contents();
  }, []);

  return (
    <div>
      {/* <h2>Folder List</h2>
      <ul>
        {folders.map((folder, index) => (
          <li key={index}>{folder}</li>
        ))}
      </ul> */}
    </div>
  );
};

export default AWSManagement;
